export type InsightsLoading = "skeleton" | "refreshing";

/** Styles to dim figures while refreshing data. */
export const dimmedWhile = (loading?: InsightsLoading) => ({
    opacity: loading === "refreshing" ? 0.45 : 1,
    transition: loading === "refreshing" ? "opacity 200ms ease 150ms" : "opacity 120ms ease"
});

/**
 * The two states a figure can be in while data moves: a first load has nothing to show, a refresh
 * still has the previous figure on screen and only dims it.
 */
export const insightsLoadingOf = (
    isLoading: boolean,
    isRefreshing = false,
): InsightsLoading | undefined => isLoading ? "skeleton" : isRefreshing ? "refreshing" : undefined;
